<div class="fadeintransition">
  <div class="innerpage-fullwithbanner advanced-search-div-bg text-center" [ngClass]="{'withbreadcrumbs':currentMenu!=''}" style="padding: 10px 15px;min-height:1px;">
    <h2 class="bighead" *ngIf="currentMenu!=''" style="margin-top:5px;">{{currentMenu}}</h2>
    <ul class="bread-crumbs margin-bottom-0" *ngIf="currentMenu!=''">
      <li *ngIf="this.authService.Principal() || this.authService.Seller() || this.authService.Principal1031()">
        <a (click)="onHomeBreadCrumbClick();">
          Home
          <span>|</span>
        </a>
      </li>
      <li *ngIf="!this.authService.Principal() && !this.authService.Seller() && !this.authService.Principal1031()"><a (click)="validationService.redirect('/')">Home<span>|</span></a></li>
      <li *ngIf="currentMenu!=''"><span>{{currentMenu}}</span></li>
    </ul>
    <div class="container"><h1 class="margin-bottom-15 text-left mbm-24" style="color: #fff;font-size:20px" *ngIf="currentMenu!='Favorites'">Search Available Net Lease Properties</h1></div>
    <div class="search-div advanced-search-div clearfix search-div-02 buy-page-advance-search">
      <be-property-search id="advanced-search" class="d-flex" (propertySearchCriteria)="propertySearchCriteria($event)" (loadSaveSearch)="reloadSaveSearch()"></be-property-search>
    </div>
  </div>

  <div class="section-margin pt-0" id="property-main-page">
    <div class="container container-lg min-heightcontainer">
      <div class="be-buy-page-wrap">
        <ul class="switchingproperty margin-bottom-30">
          <li class="live-heading" *ngIf="liveListingHeadingText=='Live Listing'">
            <h3 class="live-heading-h3">{{liveListingHeadingText}}</h3>
          </li>
          <li class="live-heading" *ngIf="liveListingHeadingText!='Live Listing'">
            <h3 class="live-heading-h3">{{liveListingHeadingText}} - {{getTotalCount()}}</h3>
          </li>
          <!--<ul class="filter-section buy-filter-part" style="margin: 5px 101px 2px;" *ngIf="canShowsavedSearch || authService.Broker()||authService.Principal1031()||authService.Principal()||authService.ExternalBroker()">
            <li role="menuitem" *ngIf="canShowsavedSearch || authService.Broker()"><a class="dropdown-item jst-left" href="javascript:void(0);" (click)="onSaveSearch()"> <img src="/assets/img/SaveSearch.svg">Save Search </a></li>
          </ul>-->
          <ul class="filter-section fl-drp buy-filter-part" *ngIf="(canShowsavedSearch || authService.Broker()||authService.Principal1031()||authService.Principal()||authService.ExternalBroker())&&!FilterStaus">
            <li (click)="onSaveSearch()" *ngIf="canShowsavedSearch || authService.Broker()" class="save-search-li margin-left-10 border-right-override" [ngClass]="{ 'border-right-override': showMenu() }">
              <a>
                <img src="/assets/img/SaveSearch.svg" class="margin-right-5">Save Search
              </a>
            </li>
            <li class="sortdropdown live-list-sort force-border-secondchild" style="box-shadow: none !important; border-left: 1px solid #ddd !important; height: 54px !important;padding-top:14px !important;" *ngIf="showMenu()">
              <div class="btn-group" dropdown>
                <a href="javascript:void(0);" id="button-basic" dropdownToggle type="button" class="dropdown-toggle"
                   aria-controls="dropdown-basic">
                  <span class="fa fa-ellipsis-v padding-left-10 filter-placeholder"></span>
                </a>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu filter-dropdowns search-filter" role="menu" aria-labelledby="button-basic">
                  <div (mouseenter)="savedSearchDropdown.show()"
                       dropdown
                       #savedSearchDropdown="bs-dropdown"
                       container="body"
                       triggers="manual"
                       placement="left"
                       [adaptivePosition]="false"
                       class="position-relative dropdown-hover-wrapper" style="padding-bottom:5px !important;margin-top:5px !important">

                    <a dropdownToggle
                       class="dropdown-item dropdown-toggle sp-btwn save-search"
                       (click)="false">
                      <span style="padding-left:11px !important;">
                        <img src="/assets/img/SaveSearch.svg" class="margin-right-5">
                        Saved Search
                      </span>
                      <span class="caret" style="margin-right:11px !important;"></span>
                    </a>

                    <ul *dropdownMenu class="dropdown-menu inner-sub-menu" role="menu">
                      <li role="menuitem"
                          *ngFor="let savedSearchOutputModel of savedSearchOutputModelList">
                        <a class="dropdown-item"
                           href="javascript:void(0);"
                           (click)="setSearch(savedSearchOutputModel.Guid)">
                          {{ savedSearchOutputModel.SearchName }}
                        </a>
                      </li>
                    </ul>
                  </div>
                  <li role="menuitem"  (mouseenter)="savedSearchDropdown?.hide()" *ngIf="authService.Principal1031()||authService.Principal()||authService.ExternalBroker()"><a class="dropdown-item jst-left" href="javascript:void(0);" (click)="onFilterSearchClick(filterSearch.Favorites)"><i class="fa fa-heart-o icon gray-color-icon"></i>Favorites </a></li>
                  <li role="menuitem"  (mouseenter)="savedSearchDropdown?.hide()" *ngIf="authService.Principal1031()"><a class="dropdown-item jst-left" href="javascript:void(0);" (click)="onFilterSearchClick(filterSearch.Dislike)"><i class="fa fa-thumbs-o-down icon gray-color-icon"></i>Dislike </a></li>
                </ul>
              </div>
            </li>


          </ul>
        </ul>
        <ul class="switchingproperty">
          <li class="live-heading-ul">
            <ul class="bordered be-buy-tabs">
              <li [class.active]="searchCriteria.PropertyFor == propertyFor.Sale" *ngIf="!isPropertySaleTabHidden" class="be-listing-tab">
                <a href="javascript:void(0);" (click)="onPropertyTypeTabClick(propertyFor.Sale)" class="listing-tab-buttons">
                  B+E Listings
                  <span class="countstyle">{{propertyTabCount!=null?propertyTabCount:0}}</span>
                </a>
              </li>
              <li [class.active]="searchCriteria.PropertyFor == propertyFor.Exchange1031" *ngIf="canShow1031Properties">
                <a href="javascript:void(0);" (click)="onPropertyTypeTabClick(propertyFor.Exchange1031)" class="listing-tab-buttons">
                  Net Lease Market
                  <span *ngIf="canShow1031Properties && !showIs1031Tab" class="countstyle">{{propertyCount!=null?propertyCount:0}}</span>
                </a>
              </li>
            </ul>
          </li>

          <ul class="filter-section buy-filter-part" *ngIf="!showAccessTo1031Listings">
            <li class="sortdropdown live-list-sort sortoption" *ngIf="view === 1 || view === 3">
              <div class="btn-group" dropdown>
                <a href="javascript:void(0);" id="button-basic" dropdownToggle type="button" class="dropdown-toggle"
                   aria-controls="dropdown-basic">
                  <i class="icon-sort-icon icon"></i><span>Sort {{sortOption}}</span>
                  <span class="caret"></span>
                </a>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                  <li role="menuitem" class="heading">Price</li>
                  <li role="menuitem" [class.activesort]="searchCriteria.SortValue === sort.PriceHighLow"><a class="dropdown-item" href="javascript:void(0);" (click)="onSortClick(sort.PriceHighLow)">High to Low</a></li>
                  <li role="menuitem" [class.activesort]="searchCriteria.SortValue === sort.PriceLowHigh"><a class="dropdown-item" href="javascript:void(0);" (click)="onSortClick(sort.PriceLowHigh)">Low to High</a></li>
                  <li role="menuitem" class="heading">Tenant Name </li>
                  <li role="menuitem" [class.activesort]="searchCriteria.SortValue === sort.TenantAtoZ"><a class="dropdown-item" href="javascript:void(0);" (click)="onSortClick(sort.TenantAtoZ)">A to Z</a></li>
                  <li role="menuitem" [class.activesort]="searchCriteria.SortValue === sort.TenantZtoA"><a class="dropdown-item" href="javascript:void(0);" (click)="onSortClick(sort.TenantZtoA)">Z to A</a></li>
                </ul>
              </div>
            </li>
            <li (click)="onViewChange(1)" [class.active]="view === 1">
              <a>
                <img [src]="view !== 1 ? '/assets/img/Grid_Unfilled.svg' : '/assets/img/GridFilled.svg'">
                <!--<img src="/assets/img/Grid_Unfilled.svg" *ngIf="view != 1">
                <img src="/assets/img/GridFilled.svg" *ngIf="view === 1">-->
              </a>
            </li>
            <li (click)="onViewChange(0)" [class.active]="view === 0">
              <a>
                <i class="icofont icofont-justify-all" style="color: #6F7375 !important" *ngIf="view != 0"></i>
                <i class="icofont icofont-justify-all" *ngIf="view === 0"></i>
              </a>
            </li>
            <li (click)="onViewChange(3)" [class.active]="view === 3">
              <a>
                <img src="/assets/img/MapUnfilled.svg" *ngIf="view != 3">
                <img src="/assets/img/Maps_Filled.svg" *ngIf="view === 3">
              </a>
            </li>
          </ul>
        </ul>
        <div class="row" *ngIf="!showAccessTo1031Listings">
          <div *ngIf="view === 1">
            <div class="properties-panel clear-4" *ngIf="IsLoadingPropertyCard; else cardList">
              <div class="col-md-4 col-lg-3 col-sm-6 col-xs-6 fullwidth600" *ngFor="let item of [1,2,3,4]">
                <div class="box card-skeleton">
                  <div class="skeleton skeleton-img"></div>
                  <div class="skeleton skeleton-title"></div>
                  <div class="skeleton skeleton-text"></div>
                </div>
              </div>
              <div class="col-md-4 col-lg-3 col-sm-6 col-xs-6 fullwidth600" *ngFor="let item of [1,2,3,4]">
                <div class="box card-skeleton">
                  <div class="skeleton skeleton-img"></div>
                  <div class="skeleton skeleton-title"></div>
                  <div class="skeleton skeleton-text"></div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-md-12">
            <div *ngIf="view === 0" class="table-fixed">
              <property-list-view [searchCriteria]="searchCriteria" (decrementPropertyCount)="decrementPropertyCount($event);" (propertyListCount)="updatePropertyCount($event);" (propertyPriorityChanged)="getPropertyPriorityChange()"></property-list-view>
            </div>
          </div>
          <div class="col-md-12">
            <div *ngIf="view === 3">
              <map-view [searchCriteria]="searchCriteria" (propertyListCount)="getPropertyCount($event)"></map-view>
            </div>
          </div>

          <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12" *ngIf="((!properties || properties.length === 0) && view === 1 && !IsLoadingPropertyCard)">
            <div class="nodata">
              <i class="fa fa-exclamation-triangle icon"></i>
              <p>No data available</p>
            </div>
          </div>
        </div>
        <div class="row margin-top-10 margin-left-10" *ngIf="showAccessTo1031Listings">
          <div class="col-md-12" *ngIf="showRequestLink">
            <div class="nodata">
              <i class="fa fa-exclamation-triangle icon"></i>
              <p>
                <span class="text">
                  <a class="blue-text" (click)="on1031InquiryRequest()">Click here</a> to get access to 1031 listings.
                </span>
              </p>
            </div>
          </div>
          <div class="col-md-12" *ngIf="showRequestUnderProcessing">
            <h2 class="mainhead "><span class="text">Pending Approval</span></h2>
            <div class="nodata">
              <i class="fa fa-exclamation-triangle icon"></i>
              <p>
                <span class="text">
                  Your 1031 access request is being processed. You will be notified via Email when your request has been approved.
                </span>
              </p>
            </div>
          </div>
          <div class="col-md-12" *ngIf="showEBRA">
            <app-bra-accept></app-bra-accept>
            <div class="clearfix"></div>
            <div class="text-right">
              <button class="btn btn-success btn-lg right-btn" (click)="confirmEBRAAccept()">
                Proceed
              </button>
            </div>

          </div>
          <div class="col-md-12" *ngIf="showEBRASigned && authService.Principal1031()">
            <div class="nodata">
              <i class="fa fa-exclamation-triangle icon"></i>
              <p>
                <span class="text">
                  Your 1031 access request is being processed. You will be notified via Email when your request has been approved.
                </span>
              </p>
            </div>
          </div>
          <div class="col-md-12" *ngIf="showEBRASigned && !authService.Principal1031()">
            <div class="nodata">
              <i class="fa fa-exclamation-triangle icon"></i>
              <p>
                <span class="text">
                  Your 1031 access request is processed. Please Logout and Relogin to view the 1031 Listings.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #logOutPopUp>
  <div class="modal-body ">
    <img alt="logo" class="whitelogo" src="/assets/img/logos/logo-white.png">
    <h3 class="blueunderlinehead"><span>Log out</span></h3>
    <div class="form-group">
      <p>Are you sure you want to logout ?</p>
    </div>
    <div class="margin-section">

      <button class="loginbtn" (click)="this._auth0.logout();this._auth0.modalRefLogout.hide();">Log Out</button>
    </div>
    <section class="margin-section forgotpassword">


      <button class="cancel-link" (click)="this._auth0.modalRefLogout.hide()">Cancel</button>
    </section>
  </div>
</ng-template>
<ng-template #loginpopup>
  <app-login-form [modalRef]="modalRefLogin"></app-login-form>
</ng-template>
<ng-template #AcceptTC>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Confirmation</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefTC.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <p style="margin-bottom:20px;">
        By accepting the participation terms, you agree to B+E's website<br />
        <a href="{{Validation.WPSiteUrl}}terms-and-conditions" target="_blank" class="a-link">terms of service</a>, and
        <a href="{{Validation.WPSiteUrl}}privacy-policy" target="_blank" class="a-link">privacy policy</a>
        , which includes:
      </p>
      <ul class="tick-list">
        <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i> To pay B+E a commission in the event that a purchase or other transaction ultimately occurs with respect to property found on the B+E website.</li>
        <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i> To keep information obtained from the B+E website confidential.</li>
        <li><i class="fa fa-dot-circle-o" aria-hidden="true"></i> To direct any solicitations or inquiries regarding property found on the B+E website through the B+E website and/or a B+E broker.</li>
      </ul>

    </div>
    <div class="clearfix"></div>
    <div class="text-right">
      <button class="btn btn-default btn-lg" (click)="modalRefTC.hide();">Cancel</button>
      <button class="btn btn-success btn-lg" (click)="onBRAAccept();">I Accept</button>
    </div>
  </div>
</ng-template>
<ng-template #cardList>
  <div class="properties-panel clear-4" (window:scroll)="onScroll($event)">
    <div class="col-md-4 col-lg-3 col-sm-6 col-xs-6 fullwidth600" *ngFor="let item of properties" #cardList>
      <be-property-card [property]="item" (propertyPriorityChanged)="getPropertyPriorityChange()"></be-property-card>
    </div>
  </div>
</ng-template>

<button id="openModalButton" [hidden]="true" (click)="openLoginModal(loginpopup,'commonmodal')"></button>
